module.exports = {"150206001":"矿山路街道","150206002":"通阳道街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150206.json
// module id = 406
// module chunks = 0